import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  searchBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    position: 'relative',
  },
  searchInputDescription: {
    fontSize: '1.4rem',
  },
  searchInput: {
    alignSelf: 'end',
  },
  filterList: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '20rem',
    overflowY: 'auto',
    margin: 0,
    border: `0.1rem solid ${colors.neutral[200]}`,
    backgroundColor: colors.neutral.white,
    padding: '0',
    borderRadius: '0.4rem',
    width: '30rem',
    boxSizing: 'border-box',
    top: '8rem',
    position: 'absolute',
    zIndex: 1,
    boxShadow: 'rgba(0, 0, 0, 0.16) 4px 7px 4px -4px',
  },
  filterItem: {
    fontSize: '1.4rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
    lineHeight: '2.4rem',
    cursor: 'pointer',
    padding: '1rem',
    wordBreak: 'break-word',
    '&:not(:last-child)': {
      borderBottom: `0.1rem solid ${colors.neutral[200]}`,
    },
    '&:hover': {
      backgroundColor: colors.blue[100],
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
